<template>
  <div ref="root" data-complex-activity="true">
    <b-tabs>
      <slot>


      </slot>
    </b-tabs>

    <b-container :fluid="fluidBottomLine">
      <b-row no-gutters class="p-0 m-0">
        <slot name="bottomLine"></slot>
      </b-row>
    </b-container>

    <!-- FOOTER -->
    <footer-navbar >
      <close-button @close="close" :read-only="allInReadOnlyMode"></close-button>
      <save-and-close-button
          v-if="!allInReadOnlyMode"
          :enabled="saveAllEnabled"
          :mode="createMode ? 'NEW' : 'EDIT'"
          @save="save"
      ></save-and-close-button>
    </footer-navbar>
    <!-- FOOTER END -->
  </div>
</template>

<script>
import FormHeader from "@/components/forms/FormHeader";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterButton from "@/components/navbar/FooterButton";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import CloseButton from "@/components/navbar/CloseButton";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
export default {
  name: "ComplexActivity",
  components: {SaveAndCloseButton, CloseButton, VBox, FooterNavbar, FooterButton, HeadersButtonGroup, FormHeader},
  props: {
    saveAllEnabled: {type: Boolean, default: true},
    allInReadOnlyMode: {default: true},
    createMode: {default: false},
    fluidBottomLine: {default: false}
  },
  methods: {
    close(){
      ActivityManager.closeTopActivity();
    },
    save(autoClose=true){
        this.$emit("saveAll", autoClose);
    },
  }
}
</script>

<style scoped>

</style>